/**
 * Centralised SEO configuration.
 * `SeoManager` (per-route <title>/description/canonical/OG) and `Analytics`
 * (GA page_view on navigation) both read from here, so page metadata lives in
 * one place — swap for a CMS payload later, like the rest of src/data.
 */

export const SITE_URL = 'https://e-waste.nishantindustries.tech';
export const BRAND = 'Green Circuit Recycling';
export const GA_MEASUREMENT_ID = 'G-EC53YKBYR4';

export const DEFAULT_DESCRIPTION =
  'Compliant corporate e-waste management in India — doorstep pickups, certified data destruction, EPR credits and recycling certificates from Green Circuit Recycling.';

/** Per-route metadata, keyed by pathname. */
export const pageSeo = {
  '/': {
    title: 'Green Circuit Recycling — Corporate E-Waste Management in India',
    description: DEFAULT_DESCRIPTION,
  },
  '/about': {
    title: 'About Us',
    description:
      'Green Circuit Recycling is an e-waste management and IT asset disposition company helping Indian enterprises dispose of electronics compliantly and sustainably.',
  },
  '/services': {
    title: 'Services',
    description:
      'Corporate e-waste pickup, certified data destruction, EPR credit management, Form 6 issuance and IT asset disposition — end-to-end e-waste services across India.',
  },
  '/industries': {
    title: 'Industries We Serve',
    description:
      'E-waste recycling for IT, BFSI, healthcare, manufacturing, education and government — sector-specific handling, data security and compliance across India.',
  },
  '/process': {
    title: 'Our Process',
    description:
      'From pickup request to recycling, compliance documentation and EPR credits — see the transparent, auditable e-waste workflow of Green Circuit Recycling.',
  },
  '/compliance': {
    title: 'Compliance & Certifications',
    description:
      'Compliant e-waste disposal under the E-Waste (Management) Rules 2022 — recycling certificates, data destruction records and EPR credits from Green Circuit Recycling.',
  },
  '/contact': {
    title: 'Contact Us',
    description:
      'Contact Green Circuit Recycling to book a corporate e-waste pickup or request a quotation. Based in Faridabad, Haryana, serving enterprises across India.',
  },
  '/request-pickup': {
    title: 'Request a Pickup',
    description:
      'Request a free corporate e-waste pickup and quotation from Green Circuit Recycling. Share your inventory and get a compliant collection scheduled with full documentation.',
  },
};

/** Routes exposed in sitemap.xml — keep in sync with App.js. */
export const indexableRoutes = Object.keys(pageSeo);

/**
 * Resolve the effective SEO for a pathname. Unknown paths (the 404 route)
 * fall back to the default copy and are marked noindex.
 */
export function resolveSeo(pathname) {
  const meta = pageSeo[pathname];

  if (!meta) {
    return {
      title: `Page Not Found — ${BRAND}`,
      description: DEFAULT_DESCRIPTION,
      canonical: `${SITE_URL}${pathname}`,
      noindex: true,
    };
  }

  return {
    title: meta.title.includes(BRAND) ? meta.title : `${meta.title} — ${BRAND}`,
    description: meta.description,
    canonical: `${SITE_URL}${pathname}`,
    noindex: false,
  };
}
